var cache = null

export default function(o, done){

  var server = o.util.getUrl('frontend')

  if(cache){
    requestAnimationFrame(function(){
      done(cache)
    })
  } else {
    $.ajax({
      url: `${server}?type=content`,
      type: "GET",
      cache: false,
      headers: { "cache-control": "no-cache" },
    })
    .done(function(data, textStatus, jqXHR) {
      cache = data
      done(data)
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
      console.error('error loading content data')
      done()
    })
  }

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/data/content/content.js